import React from 'react';

import Ribbon from '../../components/Ribbon/Ribbon';
import Container from '../../components/Container/Container';
import Input from '../../components/Input/Input';
import Button from '../../components/Button/Button';
import s from './Drivers.module.css';
import DriversCard from '../../components/DriversCard/DriversCard';
import { useState } from 'react';
import drivers from '../../JSON/drivers.json';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import NotFound from '../notFound/NotFound';

export default function Drivers() {
  const [query, setQuery] = useState('');
  const [searchResult, setSearchResult] = useState([]);

  const onSubmit = query => {
    setQuery(query);
    setSearchResult([]);
  };

  const onChange = event => {
    setSearchResult(event.target.value);
  };

  const normalizeContacts = query.toLowerCase();
  const filteredContacts = drivers.filter(driver =>
    driver.title.toLowerCase().includes(normalizeContacts),
  );
  // const sendMail = () => {
  //     const mailto =
  //       'mailto:mail@gmail.com?subject=Test subject&body=Body content';
  //     window.location.href = mailto;
  //   };

  return (
    <>
      <div className={s.drivers}>
        <Container>
          <section>
            <h1 className={s.titleSection}>ДРАЙВЕРА ТА ПІДТРИМКА</h1>
            <div className={s.inputDrivers}>
              <Input
                width="130%"
                top="50%"
                left="41%"
                onSubmit={onSubmit}
                onChange={onChange}
              />
            </div>
          </section>
        </Container>
      </div>

      <div className={s.find}>
        <div className={s.ribbon}>
          <Ribbon />
        </div>
        {filteredContacts.length < 1 && (
          <div className={s.NotFound}>
            <div className={s.backgroundImage}></div>
            <div className={s.notFoundTextWrapper}>
              <p className={s.notFoundText}>
                Схоже, даної сторінки не існує... <br />
                Але нехай тебе це не зупиняє!
              </p>
            </div>
          </div>
        )}
        <Container>
          {query && <DriversCard products={filteredContacts} />}
        </Container>
      </div>
      <div className={s.help}>
        <div className={s.ribbon}>
          <Ribbon />
        </div>
        <Container>
          <h2 className={s.sectionTitle}>Потрібна допомога?</h2>
          <div className={s.descriptionThumb}>
            <p className={s.description}>
              Не знайшли те, що шукали? Не хвилюйтеся, ми вам допоможемо! Наша
              служба підтримки складається з технічного персоналу і гравців, які
              володіють практично всіма необхідними знаннями про товари GAMERPO.
            </p>
            <p className={s.description}>
              Якщо вже вони не зможуть вам допомогти, то цього не зробить ніхто.
            </p>
          </div>
          <a href="tel:+380507746246">
            <Button name={"Зв'яжіться з нами"} border="#FFFFFF"></Button>
          </a>
        </Container>
      </div>
      <ToastContainer
        autoClose={3000}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}
